class String {
    /**
     * 下划线转驼峰
     * @param isFirstUp 是否首字母大写
     */
    toCamelCace = (value: string, isFirstUp = false) => {
        if (!value) return '';
        const str = value.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase());
        return isFirstUp
            ? str.slice(0, 1).toUpperCase() + str.slice(1)
            : str;
    };
}

export default new String();
